import { UiLocale } from '../../models/Base';
import { SystemStatus } from '../../models/SystemStore/system';
import { Regions } from '../../models/SystemStore/SystemStore';
import restClient, { RestRequestOptions, RestResponse } from './';

export const getStatus = (
  options?: RestRequestOptions,
): Promise<RestResponse<SystemStatus>> => {
  return restClient.get('/system/status', {}, options);
};

interface RegionsData {
  regions: Regions;
}
export const getRegions = (
  params: { locale?: UiLocale; from?: string } = {},
  options?: RestRequestOptions,
): Promise<RestResponse<RegionsData>> => {
  return restClient.get('/system/regions', params, options);
};
